import PropTypes from 'prop-types'
import { useState, useEffect, useContext } from 'react'
import sinfoto from '../../../src/img/perfil.jpg'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { UsuarioContext } from '../context/usuarioContext'
import * as imagenesPerfilService from '../servicios/imagenesPerfilService'

const NO_CONTENT = 204

const ImagenPerfil = ({ idUsuario, clase }) => {
  const [imagenUrl, setImagenUrl] = useState(sinfoto)
  const [loading, setLoading] = useState(true)

  const { imagenModif } = useContext(UsuarioContext)

  useEffect(() => {
    obtenerImagen()
  }, [imagenModif, idUsuario])

  const obtenerImagen = async () => {
    // Check if idUsuario is valid before making the API call
    if (!idUsuario || isNaN(idUsuario) || idUsuario <= 0) {
      setLoading(false)
      return
    }

    try {
      const TIPO_IMAGEN_PERFIL = 3
      const { data: imagenp } = await imagenesPerfilService.buscarImagen(
        idUsuario,
        TIPO_IMAGEN_PERFIL
      )
      const imagenUrl = imagenp.size !== 0 ? URL.createObjectURL(imagenp) : sinfoto
      setImagenUrl(imagenUrl)
      setLoading(false)
    } catch (error) {
      setImagenUrl(sinfoto)
      const status = error?.response?.status
      if (status !== NO_CONTENT) {
        toastErrorLog(error, 'Error al cargar la imagen', 'imagenPerfil')
      }
      setLoading(false)
    }
    //revokeObjectURL
  }
  return (
    <>
      {loading ? (
        <div className="spinner-border text-secondary">
          <span className="sr-only"></span>
        </div>
      ) : (
        <img
          src={imagenUrl}
          className={clase}
          alt="imagen perfil"
          style={{
            // width: "55px",
            width: '3.5em',
            height: '3.5em',
            borderRadius: '50%'
          }}
        ></img>
      )}
    </>
  )
}

ImagenPerfil.propTypes = {
  idUsuario: PropTypes.number.isRequired,
  clase: PropTypes.string
}

export default ImagenPerfil
